module.exports = __webpack_public_path__ + "img/bg-client-circle.674aac96.svg";